import styled from 'styled-components';

const Span = styled.span`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.text_base};
  font-weight: 300;
`;

export { Span };
